import { Moon, Sun } from 'lucide-react';
import { useAppActions, useAppState } from '../state/AppStateProvider';

const THEME_OPTIONS = [
  { value: 'light', label: 'Светлая', icon: Sun },
  { value: 'dark', label: 'Тёмная', icon: Moon },
];

export default function ThemeToggle() {
  const { theme } = useAppState();
  const { setTheme } = useAppActions();

  return (
    <div className="theme-toggle" role="radiogroup" aria-label="Тема оформления">
      {THEME_OPTIONS.map(({ value, label, icon: Icon }) => {
        const isActive = theme === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isActive}
            className={isActive ? 'theme-toggle__option active' : 'theme-toggle__option'}
            onClick={() => setTheme(value)}
          >
            <Icon size={16} aria-hidden="true" />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
